import { gql } from '../__generated__';

gql(/* GraphQL */ `
  fragment CategoryCommentModelItem on CategoryCommentModel {
    id
    text
    status
    type
    isPinned
    externalUserEmail
    createdBy {
      subjectId
      name
    }
    createdAt
    updatedBy {
      subjectId
      name
    }
    updatedAt
    closedAt
    closedBy {
      subjectId
      name
    }
    replies {
      id
      comment
      createdBy {
        subjectId
        name
      }
      createdAt
      updatedAt
    }
  }
`);

export const ADD_COMMENT = gql(/* GraphQL */ `
  mutation CategoryCreateComment($input: CategoryCreateCommentInput!) {
    categoryCreateComment(input: $input) {
      categoryCommentModel {
        ...CategoryCommentModelItem
      }
    }
  }
`);

export const DELETE_COMMENT = gql(/* GraphQL */ `
  mutation CategoryDeleteComment($input: CategoryDeleteCommentInput!) {
    categoryDeleteComment(input: $input) {
      categoryCommentModel {
        ...CategoryCommentModelItem
      }
    }
  }
`);

export const UPDATE_COMMENT = gql(/* GraphQL */ `
  mutation CategoryUpdateComment($input: CategoryUpdateCommentInput!) {
    categoryUpdateComment(input: $input) {
      categoryCommentModel {
        ...CategoryCommentModelItem
      }
    }
  }
`);

export const UPDATE_STATUS = gql(/* GraphQL */ `
  mutation CategoryUpdateCommentStatus($input: CategoryUpdateCommentStatusInput!) {
    categoryUpdateCommentStatus(input: $input) {
      categoryCommentModel {
        ...CategoryCommentModelItem
      }
    }
  }
`);

export const PIN_COMMENT = gql(/* GraphQL */ `
  mutation CategoryPinComment($input: CategoryPinCommentInput!) {
    categoryPinComment(input: $input) {
      categoryCommentModel {
        ...CategoryCommentModelItem
      }
    }
  }
`);

export const ADD_COMMENT_REPLY = gql(/* GraphQL */ `
  mutation CategoryCreateCommentReply($input: CategoryCreateCommentReplyInput!) {
    categoryCreateCommentReply(input: $input) {
      categoryCommentModel {
        ...CategoryCommentModelItem
      }
    }
  }
`);

export const UPDATE_COMMENT_REPLY = gql(/* GraphQL */ `
  mutation CategoryUpdateCommentReply($input: CategoryUpdateCommentReplyInput!) {
    categoryUpdateCommentReply(input: $input) {
      categoryCommentModel {
        ...CategoryCommentModelItem
      }
    }
  }
`);

export const DELETE_COMMENT_REPLY = gql(/* GraphQL */ `
  mutation CategoryDeleteCommentReply($input: CategoryDeleteCommentReplyInput!) {
    categoryDeleteCommentReply(input: $input) {
      categoryCommentModel {
        ...CategoryCommentModelItem
      }
    }
  }
`);
